
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "FCODRF",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/FCODRF.vue